import React, { useState } from "react";
import { Search, Download, Plus, MoreHorizontal, Eye, Edit, Power } from "lucide-react";
import { binData } from "../../DemoClient/Data/mockData";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../DemoClient/Components/Table";
import { DownloadCsv } from "retro/Utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../DemoClient/Components/Dialog";
import { Label } from "../../DemoClient/Components/label";
import { Button } from "retro";
import Moment from "moment";    

export default function InActive({ onCreateNew , onEditBin }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [brandFilter, setBrandFilter] = useState("all");
  const [cardTypeFilter, setCardTypeFilter] = useState("all");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const handleView = (bin) => {
    setModalData(bin);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };
  
  const handleToggleStatus = (bin) => { 
    bin.status = bin.status === "Inactive" ? "Active" : "Inactive";
    setModalData(bin);
  };

  const getBrandColor = (brand) => {
    return brand === "Visa"
      ? { backgroundColor: "#DBEAFE", color: "#1D4ED8", border: "1px solid #BFDBFE" }
      : { backgroundColor: "#FFEDD5", color: "#C2410C", border: "1px solid #FED7AA" };
  };

  const getCardTypeColor = (type) => {
    const colors = {
      Corporate: { backgroundColor: "#EFF6FF", color: "#1D4ED8", border: "1px solid #BFDBFE" },
      Travel: { backgroundColor: "#F5F3FF", color: "#6B21A8", border: "1px solid #DDD6FE" },
      Fuel: { backgroundColor: "#FEF3C7", color: "#B45309", border: "1px solid #FCD34D" },
      Procurement: { backgroundColor: "#ECFEFF", color: "#065F46", border: "1px solid #5EEAD4" },
      Project: { backgroundColor: "#FCE7F3", color: "#BE185D", border: "1px solid #FBCFE8" },
    };
    return colors[type] || { backgroundColor: "#F3F4F6", color: "#6B7280", border: "1px solid #D1D5DB" };
  };

  const getStatusColor = (status) => {
    return status === "Active"
      ? { backgroundColor: "#DCFCE7", color: "#166534", border: "1px solid #86EFAC" }
      : { backgroundColor: "#FEE2E2", color: "#991B1B", border: "1px solid #FECACA" };
  };

  // Filter the data based on search and dropdowns
  const filteredBins = binData.filter((bin) => {
    const matchesSearch =
      bin.bin.includes(searchTerm) ||
      bin.binName.includes(searchTerm) ||
      bin.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
      bin.cardType.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesBrand = brandFilter === "all" || bin.brand.toLowerCase() === brandFilter;
    const matchesCardType = cardTypeFilter === "all" || bin.cardType.toLowerCase() === cardTypeFilter;

    return matchesSearch && matchesBrand && matchesCardType ;
  });

  const inactiveBins = filteredBins.filter((bin) => bin.status === "Inactive");

  const downloadData = () => {
    const headers = ['BIN', 'Brand', 'Card Type'];
  
    const rows = inactiveBins.map((bin) => [
      bin.bin,
      bin.brand,
      bin.cardType,
    ]);
  
    const csvData = [headers, ...rows];
  
    DownloadCsv(
      `inactive_bins_${Moment().format('DD_MM_YYYY')}.csv`,
      csvData
    );
  };
  

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      {/* Filters */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          {/* Search */}
          <div style={{ position: "relative" }}>
            <Search
              style={{
                position: "absolute",
                left: "0.75rem",
                top: "50%",
                transform: "translateY(-50%)",
                width: "1rem",
                height: "1rem",
                color: "#6B7280",
              }}
            />
            <input
              type="text"
              placeholder="Search BINs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "20rem",
                padding: "0.5rem 0.75rem 0.5rem 2rem",
                borderRadius: "0.375rem",
                border: "1px solid #D1D5DB",
                backgroundColor: "#F9FAFB",
              }}
            />
          </div>

          {/* Brand Filter */}
          <select
            value={brandFilter}
            onChange={(e) => setBrandFilter(e.target.value)}
            style={{
              width: "10rem",
              padding: "0.5rem",
              borderRadius: "0.375rem",
              border: "1px solid #D1D5DB",
              backgroundColor: "#F9FAFB",
            }}
          >
            <option value="all">All Brands</option>
            <option value="visa">Visa</option>
            <option value="mastercard">Mastercard</option>
          </select>

          {/* Card Type Filter */}
          <select
            value={cardTypeFilter}
            onChange={(e) => setCardTypeFilter(e.target.value)}
            style={{
              width: "10rem",
              padding: "0.5rem",
              borderRadius: "0.375rem",
              border: "1px solid #D1D5DB",
              backgroundColor: "#F9FAFB",
            }}
          >
            <option value="all">All Types</option>
            <option value="corporate">Corporate</option>
            <option value="travel">Travel</option>
            <option value="fuel">Fuel</option>
            <option value="procurement">Procurement</option>
            <option value="project">Project</option>
          </select>

        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "0.75rem" }}>
          <button
            style={{
              display: "flex",
              alignItems: "center",
              padding: "0.375rem 0.75rem",
              borderRadius: "0.375rem",
              border: "1px solid #D1D5DB",
              backgroundColor: "white",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
            onClick={downloadData}
          >
            <Download style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }} />
            Export
          </button>

          <button
            onClick={onCreateNew}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "0.375rem 0.75rem",
              borderRadius: "0.375rem",
              border: "none",
              backgroundColor: "#2563EB",
              color: "white",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            <Plus style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }} />
            Create BIN
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto", marginTop: "1rem" }}>
        <Table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1000px" }} maxHeight="530px">
          <TableHeader>
            <TableRow style={{ backgroundColor: "#F3F4F6" }}>
              {[
                "BIN",
                "Name",
                "Card Scheme",
                "Card Type",
                "Level",
                "Funding",
                "Currency",
                "Usage",
                "Nature",
                "Status",
                "Created At",
                "Actions",
              ].map((head) => (
                <TableHead
                  key={head}
                  style={{
                    fontWeight: 600,
                    textAlign: head === "Actions" ? "right" : "left",
                    padding: "0.5rem 0.75rem",
                    borderBottom: "1px solid #E5E7EB",
                  }}
                >
                  {head}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {inactiveBins && inactiveBins.length > 0 ? inactiveBins.map((record) => (
              <TableRow
                key={record.id}
                style={{
                  borderBottom: "1px solid #E5E7EB",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <TableCell style={{ fontFamily: "monospace", fontWeight: 500, padding: "0.5rem 0.75rem" }}>
                  {record.bin}
                </TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.binName}</TableCell>
                <TableCell>
                  <span
                    style={{
                      padding: "0.25rem 0.5rem",
                      borderRadius: "0.375rem",
                      display: "inline-block",
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      ...getBrandColor(record.brand),
                    }}
                  >
                    {record.brand}
                  </span>
                </TableCell>
                <TableCell>
                  <span
                    style={{
                      padding: "0.25rem 0.5rem",
                      borderRadius: "0.375rem",
                      display: "inline-block",
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      ...getCardTypeColor(record.cardType),
                    }}
                  >
                    {record.cardType}
                  </span>
                </TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.cardLevel}</TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.fundingType}</TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.currency}</TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.countryUsage}</TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.cardNature}</TableCell>

                <TableCell>
                  <span
                    style={{
                      padding: "0.25rem 0.5rem",
                      borderRadius: "0.375rem",
                      display: "inline-block",
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      ...getStatusColor(record.status),
                    }}
                  >
                    {record.status}
                  </span>
                </TableCell>
                <TableCell style={{ color: "#6B7280", padding: "0.5rem 0.75rem" }}>{record.createdAt}</TableCell>
                <TableCell style={{ textAlign: "right", padding: "0.5rem 0.75rem", position: "relative" }}>
                  <button onClick={() => setDropdownOpen(dropdownOpen === record.id ? null : record.id)} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "2rem", height: "2rem", borderRadius: "0.375rem", border: "1px solid #D1D5DB", backgroundColor: "white", cursor: "pointer" }}>
                    <MoreHorizontal style={{ width: "1rem", height: "1rem" }} />
                  </button>
                  {dropdownOpen === record.id && (
                    <div style={{ position: "absolute", right: 0, top: "2.5rem", backgroundColor: "white", border: "1px solid #E5E7EB", borderRadius: "0.375rem", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", zIndex: 1000 }}>
                      <button onClick={() => handleView(record)} style={{ display: "flex", alignItems: "center", padding: "0.5rem 1rem", width: "100%", border: "none", background: "transparent", cursor: "pointer" }}><Eye style={{ marginRight: "0.5rem" }} />View Details</button>
                      <button onClick={() => onEditBin(record)} style={{ display: "flex", alignItems: "center", padding: "0.5rem 1rem", width: "100%", border: "none", background: "transparent", cursor: "pointer" }}><Edit style={{ marginRight: "0.5rem" }} />Edit BIN</button>
                      <button onClick={() => handleToggleStatus(record)} style={{ display: "flex", alignItems: "center", padding: "0.5rem 1rem", width: "100%", border: "none", background: "transparent", cursor: "pointer" }}><Power style={{ marginRight: "0.5rem" }} />{record.status === "Active" ? "Deactivate" : "Activate"}</button>
                    </div>
                  )}
                </TableCell>  
              </TableRow>
            )) : (
              <TableRow key="no-inactive-bins">
                <TableCell colSpan={10} style={{ textAlign: "center", padding: "1rem" }}>
                  No inactive bins found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>


      <Dialog open={modalVisible} onOpenChange={() => handleCloseModal()}>
       <DialogContent style={{ maxWidth: "700px" }}>
         <DialogHeader>
           <DialogTitle>BIN Details</DialogTitle>
           <DialogDescription>Complete information about this BIN</DialogDescription>
         </DialogHeader>
     
         {modalData && (
           <div style={{ display: "grid", gap: "16px", padding: "16px 0" }}>
             {[
               ["BIN", modalData.bin],
               ["Name", modalData.binName],
               ["Card Scheme", modalData.brand],
               ["Card Type", modalData.cardType],
               ["Status", modalData.status],
               ["Card Level", modalData.cardLevel],
               ["Funding Type", modalData.fundingType],
               ["Currency", modalData.currency],
               ["Country Usage", modalData.countryUsage],
               ["Card Nature", modalData.cardNature],
               ["Created At", modalData.createdAt],
             ].map(([label, value], i) => (
               <div
                 key={i}
                 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
               >
                 <Label>{label}</Label>
                 <p
                   style={{
                     margin: 0,
                     fontWeight: label === "BIN" ? "500" : "400",
                     fontFamily: label === "BIN" ? "monospace" : "inherit",
                     color: "#111827"
                   }}
                 >
                   {value || "—"}
                 </p>
               </div>
             ))}
           </div>
         )}
     
         {/* Footer */}
         <DialogFooter>
           <Button variant="outline" onClick={handleCloseModal}>
             Close
           </Button>
         </DialogFooter>
       </DialogContent>
     </Dialog>
    </div>
  );
}
